import { render, staticRenderFns } from "./FaqsIndex.vue?vue&type=template&id=decbec86&scoped=true&"
import script from "./FaqsIndex.vue?vue&type=script&lang=js&"
export * from "./FaqsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decbec86",
  null
  
)

export default component.exports